import { render, staticRenderFns } from "./ClassSelect.vue?vue&type=template&id=728bd746&scoped=true&"
import script from "./ClassSelect.vue?vue&type=script&lang=js&"
export * from "./ClassSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClassSelect.vue?vue&type=style&index=0&id=728bd746&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728bd746",
  null
  
)

export default component.exports